/**
 * Composable for managing Sizebay-related custom events
 *
 * Provides methods to emit custom events for Sizebay integration
 *
 * @returns {Object} Sizebay event methods
 * @property {Function} emitSizebayProductViewEvent - Emit a product view event
 *
 * @example
 * const { emitSizebayProductViewEvent } = useSizebayEvents()
 * emitSizebayProductViewEvent('product123', 'Blue Shirt')
 */
export const useSizebayEvents = () => {
  /**
   * Emits a custom 'product_view' event for Sizebay tracking
   *
   * @param {string} [productId=''] - Unique identifier of the product
   * @param {string} [productTitle=''] - Title or name of the product
   *
   * @description
   * - Dispatches a custom event with product details
   * - Useful for tracking product views in Sizebay integration
   *
   * @example
   * emitSizebayProductViewEvent('ABC123', 'Classic Blue Jeans')
   */
  const emitSizebayProductViewEvent = (
    productId?: string,
    productTitle?: string
  ) => {
    const productViewEvent = new CustomEvent('product_view', {
      detail: {
        productId: productId ?? '',
        productTitle: productTitle ?? '',
      },
    })
    window.dispatchEvent(productViewEvent)
  }

  return {
    emitSizebayProductViewEvent,
  }
}
